import { useQuery } from '@tanstack/react-query'
import { queueApi } from '@/api/queue'

export function useQueueStatus() {
  return useQuery({
    queryKey: ['queue-status'],
    queryFn: queueApi.getStatus,
    refetchInterval: 10000, // Refresh every 10 seconds
  })
}

export function useQueueDashboard() {
  return useQuery({
    queryKey: ['queue-dashboard'],
    queryFn: queueApi.getDashboard,
    refetchInterval: 10000, // Refresh every 10 seconds
  })
}

export function useQueueHealth() {
  return useQuery({
    queryKey: ['queue-health'],
    queryFn: queueApi.checkHealth,
    refetchInterval: 30000, // Refresh every 30 seconds
  })
}

export function useActiveConferences() {
  return useQuery({
    queryKey: ['queue-active'],
    queryFn: queueApi.getActive,
    refetchInterval: 5000, // Refresh every 5 seconds
  })
}

export function useProcessingSessions() {
  return useQuery({
    queryKey: ['queue-processing'],
    queryFn: queueApi.getProcessing,
    refetchInterval: 5000,
  })
}

export function useWaitingSessions() {
  return useQuery({
    queryKey: ['queue-waiting'],
    queryFn: queueApi.getWaiting,
    refetchInterval: 10000,
  })
}
